<div class="modal-container">
	<mat-dialog-content>
		<mat-dialog-actions>
			<button mat-fab color="warn" id="closeButton" aria-label="Close" title="Close" (click)="onClose()">
				<mat-icon>close</mat-icon>
			</button>
		</mat-dialog-actions>
		<img width="auto" height="90%" [src]="data.imageUrl" alt="Modal Image">
	</mat-dialog-content>
</div>
